// extracted by mini-css-extract-plugin
export default {"active":"styles_active__+iwgL","link":"styles_link__UNiv4","list":"styles_list__xu9Sk"};